import React from 'react';

import PropTypes from 'prop-types';

import theme from 'ui/theme';
import MainFont from 'ui/typography/mainFont';

import { IconSC, Label } from './style';

const Icon = ({
  type,
  position,
  onClick,
  size,
  color,
  disabled,
  top,
  left,
  bottom,
  right,
  rotate,
  label,
  hidden
}) => {
  return (
    <IconSC
      className={type}
      position={position}
      top={top}
      left={left}
      bottom={bottom}
      right={right}
      onClick={onClick && !disabled ? onClick : null}
      size={size}
      color={color}
      disabled={disabled}
      rotate={rotate}
    >
      {label && (
        <Label>
          <MainFont type="bold">{label}</MainFont>
        </Label>
      )}
    </IconSC>
  );
};

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  position: PropTypes.oneOf(['absolute', 'relative', 'center']),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  rotate: PropTypes.number,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hidden: PropTypes.bool
};

Icon.defaultProps = {
  position: 'relative',
  size: '12',
  color: theme().colors.black.one,
  hidden: false
};

export default Icon;
